import reducer from './reducers';
import * as userOperations from './actions';

export { userOperations };

export default reducer;
